import root from 'window-or-global';
import {Logger, createClassLogger} from '../../../../utils/Logging';

const logger: Logger = createClassLogger('YTManager').off();

type CallbackFn = (YT) => void;

let isInitialized = false;
let isApiReady = false;
const subscribers: Record<string, CallbackFn> = {};

const addYouTubeApi = () => {
    const document = root.document;
    const tag = document.createElement('script');
    tag.id = 'youtubeApi';
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

const addYouTubeIframeAPIReady = () => {
    root.onYouTubeIframeAPIReady = () => {
        logger.log('onYouTubeIframeAPIReady');
        isApiReady = true;
        Object.keys(subscribers).forEach((videoId: string) => {
            subscribers[videoId](root.YT);
        });
    };
};

export const initialize = () => {
    logger.log('initialize', {isInitialized});
    if (!isInitialized) {
        addYouTubeApi();
        isInitialized = true;
    }

    if (!root.onYouTubeIframeAPIReady) {
        addYouTubeIframeAPIReady();
    }
};

export const subscribe = (videoId: string, callback: CallbackFn) => {
    subscribers[videoId] = callback;
    if (isApiReady) {
        subscribers[videoId](root.YT);
    }
    logger.log('subscribe', subscribers);
};

export const unsubscribe = (videoId: string) => {
    delete subscribers[videoId];
    logger.log('unsubscribe', subscribers);
};
